import { createContext } from 'react';
const CardContext = createContext();
export default CardContext;